import { Link } from "react-router-dom";
import artImg from '../../assets/images/art.png'

export default function Blog(){
    return (
        <section className="blog">
            <div className="control-wrapper">
                <div className="btn-wrapper">
                   <div className="art-btn art-btn-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                            d="M9.57 5.93018L3.5 12.0002L9.57 18.0702"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                            <path
                            d="M20.5 12H3.67004"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                        </svg>
                        </div>

                        <div className="art-btn art-btn-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                            d="M14.4301 5.93018L20.5001 12.0002L14.4301 18.0702"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                            <path
                            d="M3.5 12H20.33"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </div>
                <div className="section-title">last articles</div>
                <div className="btb-viewmore">
                    <div className="view-more btn-viewmore">more articles</div>
                </div>
            </div>
            <div className="articles-wrapper">
                <div className="article-wrapper">
                    <div className="thumbnail" style={{backgroundImage: `url(${artImg})`}}></div>
                    <div className="top-detail">
                        <div className="article-title">Introduction to Kubernetes for Developers</div>
                        <div className="wrote-by">write by: Nasir Ahmad Ahmady</div>
                    </div>
                    <div className="des">As the world of software development continues to evolve, managing and deploying applications at scale has become more complex.</div>
                    <div className="article-detail">
                        <Link className="reade-more btn-viewmore">read more</Link>
                        <div className="read-time">5 min read</div>
                    </div>
                </div>
                <div className="article-wrapper">
                    <div className="thumbnail" style={{backgroundImage: `url(${artImg})`}}></div>
                    <div className="top-detail">
                        <div className="article-title">Introduction to Kubernetes for Developers</div>
                        <div className="wrote-by">write by: Nasir Ahmad Ahmady</div>
                    </div>
                    <div className="des">As the world of software development continues to evolve, managing and deploying applications at scale has become more complex.</div>
                    <div className="article-detail">
                        <Link className="reade-more btn-viewmore">read more</Link>
                        <div className="read-time">5 min read</div>
                    </div>
                </div>
                <div className="article-wrapper">
                    <div className="thumbnail" style={{backgroundImage: `url(${artImg})`}}></div>
                    <div className="top-detail">
                        <div className="article-title">Introduction to Kubernetes for Developers</div>
                        <div className="wrote-by">write by: Nasir Ahmad Ahmady</div>
                    </div>
                    <div className="des">As the world of software development continues to evolve, managing and deploying applications at scale has become more complex.</div>
                    <div className="article-detail">
                        <Link className="reade-more btn-viewmore">read more</Link>
                        <div className="read-time">5 min read</div>
                    </div>
                </div>
                <div className="article-wrapper">
                    <div className="thumbnail" style={{backgroundImage: `url(${artImg})`}}></div>
                    <div className="top-detail">
                        <div className="article-title">Introduction to Kubernetes for Developers</div>
                        <div className="wrote-by">write by: Nasir Ahmad Ahmady</div>
                    </div>
                    <div className="des">As the world of software development continues to evolve, managing and deploying applications at scale has become more complex.</div>
                    <div className="article-detail">
                        <Link className="reade-more btn-viewmore">read more</Link>
                        <div className="read-time">5 min read</div>
                    </div>
                </div>
                <div className="article-wrapper">
                    <div className="thumbnail" style={{backgroundImage: `url(${artImg})`}}></div>
                    <div className="top-detail">
                        <div className="article-title">Introduction to Kubernetes for Developers</div>
                        <div className="wrote-by">write by: Nasir Ahmad Ahmady</div>
                    </div>
                    <div className="des">As the world of software development continues to evolve, managing and deploying applications at scale has become more complex.</div>
                    <div className="article-detail">
                        <Link className="reade-more btn-viewmore">read more</Link>
                        <div className="read-time">5 min read</div>
                    </div>
                </div>
            </div>
        </section>
    )
}